import {
  User,
  Settings,
  FileText,
  Home,
  DollarSign,
  Clock,
  Coffee,
  AlertTriangle,
  UsersRound,
  MessageSquare,
} from "lucide-react";
import { createAvatar } from "../utils/adminLevelUtils";

export const getNavItems = (t) => [
  {
    icon: User,
    text: t.profile,
    page: "professionalProfile"
  },
  {
    icon: Clock,
    text: t.attendance,
    page: "attendance",
  },
  {
    icon: DollarSign,
    text: t.salaryBenefits,
    page: "salary",
  },
  {
    icon: FileText,
    text: t.employeeSelfServices,
    page: "employee-services",
  },
  {
    icon: Home,
    text: t.calendar,
    page: "calendar",
  },
  {
    icon: MessageSquare,
    text: t.messages,
    page: "messages",
  },
  {
    icon: Coffee,
    text: t.leaveManagement,
    page: "leave-management",
  },
  {
    icon: AlertTriangle,
    text: t.escalation,
    page: "escalation",
  },
  {
    icon: UsersRound,
    text: t.groups,
    page: "groups",
  },
  {
    icon: Settings,
    text: t.settings,
    page: "settings",
  },
];

export const buildEmployeeData = (profile, t) => {
  const _phone     = profile?.employeePhone         || localStorage.getItem("employeePhone")         || "";
  const _emergency = profile?.emergencyPhoneNumber  || localStorage.getItem("emergencyPhoneNumber")  || "";
  const _name      = profile?.employeeName          || localStorage.getItem("employeeName")          || t.unknownEmployee;
  return {
    id:               profile?.infinityCode                  || localStorage.getItem("infinityCode")                  || "EMP001",
    name:             _name,
    position:         profile?.position ?? profile?.employeeType ?? localStorage.getItem("employeeType") ?? "--",
    department:       profile?.department ?? profile?.employeeType ?? localStorage.getItem("employeeType") ?? "--",
    email:            profile?.employeeEmail                 || localStorage.getItem("employeeEmail")                 || localStorage.getItem("email") || "employee@company.com",
    phone:            _phone ? "+20" + _phone : "--",
    address:          profile?.address                       || localStorage.getItem("address")                       || localStorage.getItem("location") || "--",
    joinDate:         profile?.hiringDate                    || localStorage.getItem("hiringDate")                    || null,
    employeeId:       profile?.infinityCode                  || localStorage.getItem("infinityCode")                  || "EMP001",
    manager:          profile?.firstLineManagerName          || localStorage.getItem("firstLineManagerName")          || "--",
    status:           profile?.employeeState                 || localStorage.getItem("employeeState")                 || t.activeStatus,
    avatar:           createAvatar(_name),
    birthDate:        profile?.DoB                           || localStorage.getItem("DoB")                           || null,
    nationalId:       profile?.nationalId                    || localStorage.getItem("nationalId")                    || "--",
    emergencyContact: _emergency ? "+20" + _emergency : "--",
    workLocation:     profile?.location                      || localStorage.getItem("location")                      || "--",
    firstLevelManager: profile?.firstLineManagerInfinityCode || localStorage.getItem("firstLineManagerInfinityCode") || "--",
  };
};

export const buildSalaryData = (profile) => ({
  netSalary: parseFloat(profile?.netSalary || localStorage.getItem("netSalary") || "0") || 0,
});
